import { useState } from 'react';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const platforms = [
  { key: 'wechat', label: '微信', icon: 'ri-wechat-fill', color: 'text-secondary-600' },
  { key: 'weibo', label: '微博', icon: 'ri-weibo-fill', color: 'text-primary-600' },
  { key: 'qq', label: 'QQ', icon: 'ri-qq-fill', color: 'text-accent-600' },
  { key: 'link', label: '复制链接', icon: 'ri-link', color: 'text-foreground-600' },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  const [note, setNote] = useState('');

  if (!open) return null;

  const handleClick = async (key: string) => {
    if (key === 'link') {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setNote('链接已复制到剪贴板');
      } catch {
        setNote('复制失败，请手动复制浏览器地址栏链接');
      }
      return;
    }
    setNote('演示功能：暂未接入真实的第三方分享服务');
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground-950/50"
        onClick={onClose}
        role="presentation"
      ></div>
      <div className="relative w-full max-w-sm rounded-lg bg-background-50 border border-background-200 p-5">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-heading font-bold text-base text-foreground-950">分享这篇资讯</h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <p className="text-xs text-foreground-500 line-clamp-1 mb-4">{title}</p>
        <div className="grid grid-cols-4 gap-3">
          {platforms.map((p) => (
            <button
              key={p.key}
              type="button"
              onClick={() => handleClick(p.key)}
              className="flex flex-col items-center gap-2 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className={`w-11 h-11 flex items-center justify-center rounded-full bg-secondary-100 text-2xl ${p.color}`}>
                <i className={p.icon}></i>
              </span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">{p.label}</span>
            </button>
          ))}
        </div>
        {note && (
          <p className="mt-4 text-xs text-accent-700 bg-accent-50 rounded-md px-3 py-2 text-center">{note}</p>
        )}
      </div>
    </div>
  );
}